import { UserId, UserIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "./system"

export const BlockDocumentBody = z.object({
  // ブロックされた相手 (= ドキュメント ID) の UserId を冗長に持つ。
  // ドキュメント ID 既にこの値だが、collection group クエリ
  // (`where("target_user_id", "==", X)`) で「ある退会者を block していた全 owner」
  // を逆引きするために、フィールドとしても持つ必要がある。
  target_user_id: UserIdSchema,
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type BlockDocumentBody = z.infer<typeof BlockDocumentBody>

export const BlockDocument = z.intersection(
  BlockDocumentBody,
  z.object({
    id: UserIdSchema,
  })
)

export type BlockDocument = z.infer<typeof BlockDocument>

export class Blocks {

  public static readonly LIMIT_OWN = 3000

}

export class BlockDocuments {

  static toDocumentData(block: BlockDocument): object {
    return {
      ...block,
      // id は document path に入るので入れない
      id: undefined,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): BlockDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    const id = UserId(doc.id)
    // 旧スキーマ (target_user_id 未設定) の既存ドキュメントは ID で代替する。
    // バックフィルマイグレーションで全件埋めた後はこの fallback は不要になる。
    const targetUserIdRaw = data["target_user_id"]
    const target_user_id = typeof targetUserIdRaw === "string" ? UserId(targetUserIdRaw) : id
    return {
      id,
      target_user_id,
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }

}
